import React from "react";
import Logo from "../Assets/images/android-chrome-192x192.png";
import successImg from "../Assets/images/rsz_1istockphoto-1271668207-612x612.jpg";
import failImage from "../Assets/images/rsz_istockphoto-1402586255-612x612.png";

const ReciptPage = () => {
  const status = true;
  return (
    <div className="container panel container-fluid card wd-50  wm-100 mx-auto ">
      <div className="m-5 d-flex juxtify-content-center align-items-center flex-column">
        {/* <img src={Logo} alt="loader" className="img-fluid lg-img-thumbnail"  /> */}
        {/* <img className="m-auto maxh-10 mt-2 mb-2 " alt="logo" src={Logo} /> */}
        <div>
          <img
            src={status ? successImg : failImage}
            alt="receipt status image"
            className=""
          />

          <p className="product-price text-center">{`${
            status ? "از پرداختتان متشکریم!" : "پرداخت شما موفقیت آمیز نبود!"
          } `}</p>
        </div>
        <div>
          <div className="border-bottom mb-1">
            <p className="">مبلغ پرداخت شده</p>
            <p>34877 تومان</p>
          </div>
          <div className="border-bottom mb-1">
            <p className=""> نوع پرداخت </p>
            <p>درگاه بانکی </p>
          </div>
          <div className=" mb-1">
            <p className=""> شماره ارجاع </p>
            <p>34877775566</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReciptPage;
